import React from 'react';
import { TextField } from '@mui/material';
import classes from 'Global/Styles/PersianSupport.module.scss';
import i18next from 'i18next';

import useLogic from './Logic/useLogic';

const PersianSupportTextField = ({
  label,
  onChange,
  errors,
  name,
  isPassword,
  icon,
  iconFn,
  variant,
  onlyIcon,
  CustomOnChange,

  PaddingOff = true,
  clearText,
  enableSuggest,
  isSmall = true,
  disabled = false,
  styles = {},
}) => {
  const isEnglish = i18next.language === 'en';

  const [
    Element,
    forceRender,
    initialValue,
    onChangeFn,
    password,
  ] = useLogic({
    label,
    onChange,
    icon,
    iconFn,
    onlyIcon,
    CustomOnChange,
    clearText,
    enableSuggest,
    isPassword,
  });
  return (
    <React.Fragment>
      {!PaddingOff ? (
        <div style={{ paddingBlock: '.3em' }}>
          {forceRender ? <></> : <></>}
        </div>
      ) : (
        <></>
      )}
      <TextField
        sx={{
          minHeight: '40px',
          ...styles,
        }}
        disabled={disabled}
        {...(isSmall && { size: 'small' })}
        variant={variant ?? 'outlined'}
        dir={!isEnglish ? 'rtl' : 'ltr'}
        color="colorPrimer"
        label={label}
        type={
          isPassword
            ? !password
              ? 'password'
              : 'text'
            : 'text'
        }
        defaultValue={initialValue} // Use the initial value from the ref
        onChange={(event) => {
          onChangeFn(event);
        }}
        fullWidth
        InputProps={{
          endAdornment: Element,
        }}
        InputLabelProps={
          !isEnglish
            ? {
                classes: {
                  root: classes.textFieldroot,
                  shrink: classes.textFieldShrink,
                },
              }
            : {}
        }
        FormHelperTextProps={
          !isEnglish
            ? {
                sx: {
                  textAlign: 'right',
                },
              }
            : {}
        }
        error={errors && !!errors[name]}
        helperText={
          errors && errors[name]
            ? `فیلد ${label} را پرکنید`
            : ''
        }
      />
    </React.Fragment>
  );
};

export default PersianSupportTextField;
